import meetingService from '../../services/meeting.service';

export default function useMeetingParams() {
  return meetingService.getMeetingParams();
}
